export enum PaymentType {
  Stripe = 'stripe',
  NewPaypal = 'paypal_new',
  OldPaypal = 'paypal_old',
}
